<template>
    <dl v-if="items" class="datalist" :class="[`columns-${columns}`]">
        <div v-for="item in filteredItems" class="datalist__item dataitem">
            <dt v-text="item.title" class="dataitem__title"/>
            <dd class="dataitem__value">
                <SvgIcon v-if="item.icon" :icon="item.icon"/>
                <span
                    v-text="item.value"
                    :class="{'sector': item.isSector ? item.isSector : false }"
                />
            </dd>
        </div>
    </dl>
</template>
<script>
import SvgIcon from '@components/SvgIcon.vue';

export default {
    name: 'DataList',
    components: {
        SvgIcon,
    },
    props: {
        items: {
            type: Array,
            default: [],
        },
        columns: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        filteredItems: function() {
            return this.items.filter((item) => item.value && item.value.length > 0)
        }
    }
}
</script>
<style lang="scss">
@import '~@/theme/variables';

.datalist {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 2rem 4rem;
    margin: 0;

    .datalist__item {
        flex: 0 0 auto;
    }

    &.columns-1 {
        .datalist__item {
            flex: 1 0 100%;
        }
    }

    &.columns-2 {
        .datalist__item {
            flex: 1 0 calc(50% - 4rem);
        }
    }

    &.columns-3 {
        .datalist__item {
            flex: 1 0 calc(33% - 4rem);
        }
    }

    &.columns-4 {
        .datalist__item {
            flex: 1 0 calc(25% - 4rem);
        }
    }
}

.dataitem {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: .4rem;

    .dataitem__title {
        color: $text;
        font-size: 1.4rem;
        line-height: 1.8rem;
    }

    .dataitem__value {
        display: flex;
        align-items: center;
        column-gap: .8rem;
        margin-left: 0;

        .svg-icon {
            width: 2rem;
            height: 2rem;
            margin-right: 0;
        }

        span {
            font-size: 1.4rem;
            line-height: 1.8rem;
            position: relative;
            top: .2rem;
        }

        .sector {
            margin: 0;
            max-width: 19rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        &.wrapped {
            flex-wrap: wrap;
        }
    }
}
</style>
